import { render, staticRenderFns } from "./SalarySplitPrint.vue?vue&type=template&id=41240877&scoped=true&"
import script from "./SalarySplitPrint.vue?vue&type=script&lang=js&"
export * from "./SalarySplitPrint.vue?vue&type=script&lang=js&"
import style0 from "./SalarySplitPrint.vue?vue&type=style&index=0&id=41240877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41240877",
  null
  
)

export default component.exports